module.exports = "/hwa/_next/static/images/help-desk-ee48105a754935f94e7ed9b55467a709.png";